// Careers Form JavaScript
document.addEventListener('DOMContentLoaded', function() {
  // Handle file upload styling and functionality
  const fileInputs = document.querySelectorAll('.file-upload__input');
  
  fileInputs.forEach(input => {
    input.addEventListener('change', function() {
      const label = this.previousElementSibling;
      const fileNameSpan = label.querySelector('span:first-child');
      
      if (this.files && this.files.length > 0) {
        // Show the file name in the label
        fileNameSpan.textContent = this.files[0].name;
        label.classList.add('file-selected');
      } else {
        // Reset to default text
        const defaultText = this.id === 'CareersForm-cover-letter' ? 'UPLOAD COVER LETTER' :
                           this.id === 'CareersForm-resume' ? 'UPLOAD RESUME' : 'UPLOAD PORTFOLIO';
        fileNameSpan.textContent = defaultText;
        label.classList.remove('file-selected');
      }
    });
  });
  
  // Add custom form validation
  const careersForm = document.getElementById('CareersForm');
  if (careersForm) {
    careersForm.addEventListener('submit', function(event) {
      let isValid = true;
      const requiredFields = careersForm.querySelectorAll('[required]');
      
      requiredFields.forEach(field => {
        if (!field.value.trim()) {
          isValid = false;
          field.classList.add('error');
        } else {
          field.classList.remove('error');
        }
      });
      
      if (!isValid) {
        event.preventDefault();
      }
    });
  }
  
  // Add button hover effect
  const submitButton = document.querySelector('.careers-form .button');
  if (submitButton) {
    submitButton.addEventListener('mouseover', function() {
      this.style.backgroundColor = '#444';
    });
    
    submitButton.addEventListener('mouseout', function() {
      this.style.backgroundColor = '';
    });
  }
  
  // Add custom color to the send button if specified in the design
  const allButton = document.querySelector('.all-button .button--brand-color');
  if (allButton) {
    // Check if there's a custom color attribute
    const customColor = allButton.getAttribute('data-color');
    if (customColor) {
      allButton.style.backgroundColor = customColor;
    }
  }
});